<template>
  <div :bordered='false'>
    <div class='table-page-search-wrapper'>
      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter="24">
          <a-col  :md='6' :sm='8'>
            <a-form-item label="ImportDate" >
              <a-range-picker
                v-model="queryParam.time"
                format="YYYY-MM-DD"
                style="width: 200px;"/>
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <a-form-item label="Status">
              <a-select  style='width: 190px' v-model='queryParam.status'>
                <a-select-option :value="-1" >All</a-select-option>
                <a-select-option :value="0">Not Written Off</a-select-option>
                <a-select-option :value="1">Auto Write-off</a-select-option>
                <a-select-option :value="100">Manual Transfer</a-select-option>
                <a-select-option :value="9998">Repayment Flow Invalid (Refunded)</a-select-option>
                <a-select-option :value="9997">Refund</a-select-option>
                <a-select-option :value="9999">No Action Needed</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <a-form-item label="CUIT">
              <a-input  style='width: 190px' v-model='queryParam.cuit'>
              </a-input>
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <a-form-item label="DataType">
              <a-select  style='width: 190px' v-model='queryParam.dataType'>
                <a-select-option value="" >All</a-select-option>
                <a-select-option value="payin">Repayment</a-select-option>
                <a-select-option value="payout">Disbursement</a-select-option>
                <a-select-option value="refund">Refund</a-select-option>
                <a-select-option value="null">No Type</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :md='24'  :sm='8'>
            <a-upload
              name="file"
              :multiple="true"
              :action="'/api/web/webpublic/agt/supervielle/importing'"
              :headers="getHeaders()"
              :data="uploadDataParam"
              @change="handleChangeUpload"
            >
              <a-button style='margin-left: 8px'> <a-icon type="upload" />UploadsupervielleFlow File</a-button>
            </a-upload>

            <a-upload
              name="file"
              :multiple="true"
              :action="'/api/web/webpublic/agt/supervielle/importingSantander'"
              :headers="getHeaders()"
              :data="uploadDataParam"
              @change="handleChangeUpload"
            >
              <a-button style='margin-left: 8px'> <a-icon type="upload" />UploadSantanderFlow File</a-button>
            </a-upload>

            <a-upload
              name="file"
              :multiple="true"
              :action="'/api/web/webpublic/agt/supervielle/importingBind'"
              :headers="getHeaders()"
              :data="uploadDataParam"
              @change="handleChangeUpload"
            >
              <a-button style='margin-left: 8px'> <a-icon type="upload" />UploadBindFlow File</a-button>
            </a-upload>

            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">

              <a-button type="primary" @click="downLoadData()" icon="download" style="margin-left: 8px">Export Flow
              </a-button>
            </span>
          </a-col>
          <a-col :md='12'  :sm='8'>
            <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
              <a-button type='primary' @click='searchQuery' icon='search'>{{ $t('search') }}</a-button>
              <!--<a-button type='primary' @click='searchReset' icon='reload' style='margin-left: 8px'>{{ $t('reset') }}</a-button>-->
            </span>
          </a-col>
        </a-row>
      </a-form>
      <a-table
        ref='table'
        rowKey='id'
        size='middle'
        :columns='columns'
        :dataSource='dataSource'
        :pagination='false'
        :loading='loading'
        bordered
        @change='handleTableChange'>
        <template slot="status" slot-scope="text, record">
          <a-select
            v-model="record.status"
            @change="handleStatusChange(record)"
          >
            <a-select-option :value="0">Not Written Off</a-select-option>
            <a-select-option disabled="" :value="1">Auto Write-off</a-select-option>
            <a-select-option :value="2">Manual Write-off</a-select-option>
            <a-select-option :value="100">Manual Transfer</a-select-option>
            <a-select-option :value="9998">Repayment Flow Invalid (Refunded)</a-select-option>
            <a-select-option :value="9997">Refund</a-select-option>
            <a-select-option :value="9999">No Action Needed</a-select-option>
          </a-select>
        </template>
      </a-table>
      <div style='margin-top: 15px; text-align: right;'>
        <v-pagination
          v-if='total'
          :page-num='form.pageNum'
          :page-size='form.pageSize'
          :total='total'
          @change='handleTableChange' />
      </div>
    </div>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getSupervielleList, updateStatusSupervielle } from '@/webpublicapi/importSalaryCommon'
import { getHeaders } from '@/utils/request'
import exportFile from '@/webpublicapi/exportFile'
import moment from 'moment'

const I18N_KEY = {
  OASYSTEM: 'oaSystem.',
  FOLLOW: 'importSalary.'
}
export default {
  name: 'importCommonSalary',
  components: {},
  data() {
    return {
      visdialog: false,
      I18N_KEY,
      visible: false,
      form: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      dataSource: [],
      dataSourceTotal: [],
      // Query conditions
      queryParam: {
        time: [],
        status:-1,
        cuit: null
      },
      loading: false,
      // Table header
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      },
      uploadDataParam:{
        payChannel: null,
        password: null
      },
      payoutChannelList:[]
    }
  },
  computed: {
    columns() {
      return [
        {
          title: 'id',
          align: 'left',
          dataIndex: 'id'
        },
        {
          title:  'Generation Time',
          align: 'center',
          dataIndex: 'dataTimeStr'
        },
        {
          title:  'Repayment Amount',
          align: 'center',
          dataIndex: 'flowAmount'
        },
        {
          title:  'Loan Amount',
          align: 'center',
          dataIndex: 'payoutAmount'
        },
        {
          title:  'cuit',
          align: 'center',
          dataIndex: 'cuit'
        },
        {
          title:  'Type',
          align: 'center',
          dataIndex: 'dataType'
        },
        {
          title:  'Status',
          align: 'center',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' }
        },
        {
          title:  'Created Time',
          align: 'center',
          dataIndex: 'createdTimeStr'
        },
        {
          title:  'Updated Time',
          align: 'center',
          dataIndex: 'updatedTimeStr'
        },
        {
          title:  'Bank',
          align: 'center',
          dataIndex: 'bankName'
        }

      ]
    }
  },
  created() {
    this.getTime();
    this.loadData(1)
  },
  methods: {
    getTime() {
      this.queryParam.time = [];
      var nowDate = new Date();
      this.queryParam.time[0]=moment(nowDate.setDate(nowDate.getDate() - 7));
      this.queryParam.time[1]=moment(new Date());

    },
    getHeaders() {
      return getHeaders();
    },
    searchQuery() {
      this.loadData(1)
    },
    loadData(arg) {
      var params = this.getQueryParams()// Query conditions
      if (!params.beginTime) {
        this.$message.error("Datecannot be empty");
        return;
      }
      // Load data If params passed1Then load first page content
      if (arg === 1) {
        this.form.pageNum = 1
      }
      this.loading = true

      getSupervielleList(Object.assign({}, params)).then((res) => {
        if (res.code === 1000) {
          this.total = res.data.total
          this.dataSource = res.data.rows
        } else {
          this.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    },
    downLoadData () {
      var params = this.getQueryParams()// Query conditions
      var fileUrl = '/api/web/webpublic/agt/supervielle/exportXcoop?beginTime=' + params.beginTime + '&endTime=' + params.endTime;
      if (params.cuit) {
         fileUrl += '&cuit=' + params.cuit;
      }
      if (params.status !== -1) {
         fileUrl += '&status=' + params.status;
      }
      if (params.dataType) {
         fileUrl += '&dataType=' + params.dataType;
      }

      const file = {
        fileUrl: fileUrl,
        fileName: params.beginTime + '_' + params.endTime + '.xlsx',
      }
      this.loading = true;
      exportFile(file).catch(e => {
        this.$message.error(e.message);
      }).finally(() => {
        this.loading = false;
      })
    },
    getQueryParams() {
      var param = this.queryParam;
      param.pageNum = this.form.pageNum;
      param.pageSize = this.form.pageSize;
      param.beginTime = (param.time && param.time.length) ? this.transformTime(param.time[0]) : undefined;
      param.endTime = (param.time && param.time.length) ? this.transformTime(param.time[1]) : undefined;

      return filterObj(param)
    },
    transformTime (time) {
      return time.format('YYYY-MM-DD')
    },
    handleTableChange(pageNum, pageSize) {
      this.form.pageNum = pageNum
      this.form.pageSize = pageSize
      this.loadData()
    },
    // Reset search box content
    searchReset() {
      queryParam.status = -1;
      this.getTime();
    },
    handleChangeUpload(info) {
      //debugger;
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === 'done') {
        if(info.file.response.code === 1000){
          //alert('handle success!');
          this.$message.success(`${info.file.name} file uploaded successfully`);
        } else {
          alert(info.file.response.msg);
        }
      } else if (info.file.status === 'error') {
        //this.$message.error(`${info.file.name} file upload failed.`);
        alert('system error!');
      }
    },
    handleStatusChange(records){
      this.loading = true
      updateStatusSupervielle(records).then(res=>{
        if(res.code===1000){
        }else{
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false;
        this.$message.error(e.message);
      })
    },

  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";
</style>
